<!-- ./src/pages/admin/Products.vue -->

<template src="./Agenda.html"></template>

<script>
import usuario from "@/services/usuario";
import devedores from "@/services/devedores";
import agendas from "@/services/agendas";
import moment from "moment";


  export default {
    name: 'home',
    data () {
      return {
        
        date: new Date().toISOString().substr(0, 10),
        date2: new Date().toISOString().substr(0, 10),
        dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
        dateFormatted2: this.formatDate(new Date().toISOString().substr(0, 10)),
        menu1: false,
        menu2: false,
        modal2: false,
        active: 0,
        singleSelect: true,
        dialog: false,
        dialogError: false,
        dialogConfirmation: false,
        editando: false,
        user: null,
        devedores: [],
        agendas:[],
        maskHora: '##:##',
        model: { data:new Date().toISOString().substr(0, 10) },
        headers: [{
            text: 'Nome',
            align: 'left',
            sortable: true,
            value: 'iddevedor.Nome'
          },
          {
            text: 'CPF',
            align: 'left',
            sortable: true,
            value: 'iddevedor.CnpjCpf'
          },
          {
            text: 'Data',
            align: 'left',
            sortable: true,
            value: 'data'
          },
          {
            text: 'Hora',
            align: 'left',
            sortable: true,
            value: 'hora'
          },
          { text: 'Ações', value: 'action', sortable: false },
        ]
      }
    },
    async created () {
      this.devedores = await devedores.getDevedores();
      this.agendas = await agendas.getUser(this.$store.getters.user._id, this.parseDate(this.formatDate(this.date)));
    },
    
    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
      computedDateFormatted2 () {
        return this.formatDate(this.date2)
      },
    },
    
    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
      date2 (val) {
        this.dateFormatted2 = this.formatDate(this.date2)
        this.model.data = this.date2;
      },
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      cobrar: function (item) {
        this.$router.push('/funcionario/cobranca/'+item.iddevedor._id)
      },
      novo: async function () {
        this.dialog = true;
        this.editando = false;
        this.model = { data:new Date().toISOString().substr(0, 10) };
      },
      dateChange: async function (date) {
        this.agendas = await agendas.getUser(this.$store.getters.user._id, this.parseDate(this.formatDate(this.date)));
      },
      deleteItem: async function (even) {
        if (!this.dialogConfirmation) {
          this.dialogConfirmation = true;
          this.excluindo = even;
        } else {
          await agendas.remove(even);
          this.dialogConfirmation = false;
          this.excluindo = null;
          this.agendas = await agendas.getUser(this.$store.getters.user._id, this.parseDate(this.formatDate(this.date)));
        }
      },
      editItem: async function (even) {
        
        this.devedores = await devedores.getDevedores();
        this.dialog = true;
        this.editando = true;
        this.model = even;
        
        this.model.internal = undefined;
        this.model.flags = undefined;
        if (!this.model.iddevedor) {
          this.model.iddevedor = {}
        }
        if (this.model.data) {
          this.model.data = new Date(this.model.data).toISOString().substr(0, 10);
        }
      },
      save: async function () {
        let errors = await this.$validator.validate();
        this.model.iduser = this.$store.getters.user._id;
        if (errors) {
          let res = await agendas.save(this.model);
          if (res.data && res.data.error) {
            this.message = res.data.error.data;
            this.dialogError = true;
          } else {
            this.model = {}
            this.dialog = false;
            this.agendas = await agendas.getUser(this.$store.getters.user._id, this.parseDate(this.formatDate(this.date)));
          }
          
        }
      },
      
      clear: function () {
        this.model = { data:new Date().toISOString().substr(0, 10) };
        this.editando = false;
        this.dialog = false;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/agenda/Agenda.vue